import { DataType } from "../../../../../../../models/Enums";
import { Constants } from "../../../../../../../models/Constants";
import ValidationRuleModel, {
    IValidationRuleProvider,
} from "../../../../../../../models/ValidationRuleModel";

const ValidationRules: IValidationRuleProvider = {
    noInformationSystemExists: new ValidationRuleModel(DataType.Boolean, false),
    informationSystems: new ValidationRuleModel(DataType.ArrayOfObject, true),
  [`informationSystems[${Constants.Common.IndexSubstitute}].informationSystem1`]:
    new ValidationRuleModel(
      DataType.String,
      false,
      `${Constants.Common.RootObjectNameSubstitute}.noInformationSystemExists !== true && ${Constants.Common.IndexSubstitute} !== 0 && !isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.informationSystems[0].informationSystem1) && isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.informationSystems[${Constants.Common.IndexSubstitute}].informationSystem1)`
    ),
    [`informationSystems[${Constants.Common.IndexSubstitute}].informationSystem2`]:
        new ValidationRuleModel(
            DataType.String,
            false,
            `${Constants.Common.RootObjectNameSubstitute}.noInformationSystemExists !== true && ${Constants.Common.IndexSubstitute} !== 0 && !isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.informationSystems[0].informationSystem2) && isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.informationSystems[${Constants.Common.IndexSubstitute}].informationSystem2)`
        ),
    [`informationSystems[${Constants.Common.IndexSubstitute}].informationSystem3`]:
        new ValidationRuleModel(
            DataType.String,
            false,
            `${Constants.Common.RootObjectNameSubstitute}.noInformationSystemExists !== true && ${Constants.Common.IndexSubstitute} !== 0 && !isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.informationSystems[0].informationSystem3) && isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.informationSystems[${Constants.Common.IndexSubstitute}].informationSystem3)`
        ),
    [`informationSystems[${Constants.Common.IndexSubstitute}].informationSystem4`]:
        new ValidationRuleModel(
            DataType.String,
            false,
            `${Constants.Common.RootObjectNameSubstitute}.noInformationSystemExists !== true && ${Constants.Common.IndexSubstitute} !== 0 && !isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.informationSystems[0].informationSystem4) && isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.informationSystems[${Constants.Common.IndexSubstitute}].informationSystem4)`
        ),
    metNotMetStatus: new ValidationRuleModel(
        DataType.String,
        false,
        `${Constants.Common.RootObjectNameSubstitute}.cannotBeAssessed !== true && isStringNullOrEmpty(${Constants.Common.RootObjectNameSubstitute}.metNotMetStatus)`,
        "Errors.MetNotMetSelect"
    )
};

export default ValidationRules;